import { render, staticRenderFns } from "./frontpage_blogs.vue?vue&type=template&id=49f0b4ac"
import script from "./frontpage_blogs.vue?vue&type=script&lang=js"
export * from "./frontpage_blogs.vue?vue&type=script&lang=js"
import style0 from "./frontpage_blogs.vue?vue&type=style&index=0&id=49f0b4ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports